import {
  Button,
  Table,
} from '@cloudscape-design/components';
import OrgName from 'components/Display/orgName';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

export default function UserList({
  users,
  isLoading,
  Pagination = null,
  variant = 'container',
  header,
}) {
  const navigate = useNavigate();
  const tableItems = useMemo(() => users.map((item) => ({
    ...item,
    emailButton: <Button variant="inline-link" onClick={() => navigate(`/user/${item.id}`)}>{item.email}</Button>,
    orgName: item.organization && <OrgName orgId={item.organization} />,
  })), [navigate, users]);

  return (
    <Table
      header={header}
      variant={variant}
      loading={isLoading}
      items={tableItems}
      stickyHeader
      resizableColumns
      columnDefinitions={[
        {
          id: 'name',
          header: 'User Email',
          cell: (item) => item.emailButton,
          maxWidth: 120,
        },
        {
          id: 'createdAt',
          header: 'Create Date',
          cell: (item) => item.createdAt && new Date(item.createdAt).toLocaleString(),
        },
        {
          id: 'organization',
          header: 'Organization',
          cell: (item) => item.orgName,
          maxWidth: 120,
        },
      ]}
      pagination={Pagination}
      empty={<div>No users</div>}
    />
  );
}

UserList.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    createdAt: PropTypes.string,
  })).isRequired,
  isLoading: PropTypes.bool.isRequired,
  Pagination: PropTypes.node,
  variant: PropTypes.oneOf(['container', 'full-page']),
  header: PropTypes.node.isRequired,
};
